<!-- 平台管理 - 按团队长和金额分销任务 -->
<template>
    <div>
        <admin-main-header></admin-main-header>

        <div class="admin-main-body">
            <div
                class="admin-content"
                :style="{ minHeight: adminContentMinHeight + 'px' }"
            >
                <div class="admin-content-title el-clearfix">
                    <span class="el-title-bar"> 全部分销任务</span>
                    <span class="x-task-remark">按团队长和总金额分销任务</span>
                </div>
                <div class="admin-content-main">
                    <div class="el-search-form">
                        <el-form
                            ref="dblTaskQueryForm"
                            :model="dblTaskQueryForm"
                        >
                            <el-row :gutter="20">
                                <el-col :span="3" :offset="1">
                                    <el-form-item prop="taskId">
                                        <el-input
                                            v-model="dblTaskQueryForm.taskId"
                                            clearable
                                            placeholder="任务ID"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="5">
                                    <el-form-item prop="taskProduceOrgId">
                                        <el-select
                                            v-model="
                                                dblTaskQueryForm.taskProduceOrgId
                                            "
                                            clearable
                                            filterable
                                            :filter-method="filterAllOrgs"
                                            @visible-change="
                                                resetOrgSelectFilterQuery
                                            "
                                            placeholder="任务发布方"
                                            class="el-full-width"
                                        >
                                            <el-option
                                                v-for="item in dblTaskQueryOrgSelectOptions"
                                                :key="item.orgId"
                                                :label="item.orgName"
                                                :value="item.orgId"
                                                class="org-select-option"
                                            >
                                                <span class="option-left">{{
                                                    item.orgCode
                                                }}</span>
                                                <span class="option-right">{{
                                                    item.orgName
                                                }}</span>
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="5">
                                    <el-form-item prop="taskConsumeOrgId">
                                        <el-select
                                            v-model="
                                                dblTaskQueryForm.taskConsumeOrgId
                                            "
                                            clearable
                                            filterable
                                            :filter-method="filterAllOrgs"
                                            @visible-change="
                                                resetOrgSelectFilterQuery
                                            "
                                            placeholder="任务接受方"
                                            class="el-full-width"
                                        >
                                            <el-option
                                                v-for="item in dblTaskQueryOrgSelectOptions"
                                                :key="item.orgId"
                                                :label="item.orgName"
                                                :value="item.orgId"
                                                class="org-select-option"
                                            >
                                                <span class="option-left">{{
                                                    item.orgCode
                                                }}</span>
                                                <span class="option-right">{{
                                                    item.orgName
                                                }}</span>
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item prop="distributeDateRange">
                                        <el-date-picker
                                            style="width: 95%"
                                            v-model="
                                                dblTaskQueryForm.distributeDateRange
                                            "
                                            type="daterange"
                                            format="yyyy-MM-dd"
                                            value-format="yyyy-MM-dd"
                                            start-placeholder="分派日期(开始)"
                                            end-placeholder="分派日期(结束)"
                                        >
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4">
                                    <el-form-item class="el-align-center">
                                        <el-button
                                            @click="resetDblTaskQueryForm"
                                            icon="fas fa-undo"
                                            >重 置</el-button
                                        >&nbsp;&nbsp;
                                        <el-button
                                            type="primary"
                                            @click="queryDblTaskList(1000)"
                                            icon="fas fa-search"
                                            >查 询</el-button
                                        >
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                    <div class="el-search-toolbar">
                        <el-button-group>
                            <el-button
                                type="primary"
                                size="small"
                                icon="fas fa-plus-circle"
                                @click="openDblTaskEditDialog('add')"
                                >在线分派任务</el-button
                            >
                            <el-button
                                type="primary"
                                size="small"
                                icon="fas fa-upload"
                                @click="openDblTaskImportDialog()"
                                >批量分派任务</el-button
                            >
                        </el-button-group>
                    </div>
                    <div class="el-search-list">
                        <el-table
                            ref="dblTaskTable"
                            v-loading="dblTaskQueryLoading"
                            element-loading-text="拼命加载中..."
                            element-loading-custom-class="el-loading-mask-opacity"
                            :class="{ loading: dblTaskQueryLoading }"
                            :data="dblTaskList"
                            :default-sort="dblTaskQuerySort"
                            @sort-change="onDblTaskQuerySortChange"
                            style="width: 100%"
                            class="el-table-overflow-x-hidden"
                            empty-text="暂无数据"
                        >
                            <el-table-column
                                label="#"
                                type="index"
                                width="40"
                            ></el-table-column>
                            <el-table-column
                                label="任务ID"
                                prop="taskId"
                                width="100"
                                align="center"
                                sortable
                            >
                                <template slot-scope="scope">
                                    <span>{{ scope.row.taskId }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="任务发布方"
                                prop="taskProduceOrgId"
                                sortable
                            >
                                <template slot-scope="scope">
                                    <div>
                                        {{ scope.row.taskProduceOrgName }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="任务接受方"
                                prop="taskConsumeOrgId"
                                sortable
                            >
                                <template slot-scope="scope">
                                    <div>
                                        {{ scope.row.taskConsumeOrgName }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="团队长"
                                prop="leaderStaffName"
                                width="90"
                                align="center"
                            ></el-table-column>
                            <el-table-column
                                label="分派日期"
                                prop="distributeDate"
                                width="100"
                                align="center"
                            ></el-table-column>
                            <el-table-column
                                label="分派金额"
                                prop="distributeAmounts"
                                width="100"
                                align="center"
                                sortable
                            ></el-table-column>
                            <el-table-column
                                label="含税金额"
                                prop="taxedDistributeAmounts"
                                width="100"
                                align="center"
                            ></el-table-column>
                            <el-table-column
                                label="税点"
                                prop="taxThreshold"
                                width="100"
                                align="center"
                                sortable
                            ></el-table-column>
                            <el-table-column
                                label="服务数"
                                prop="taskServiceCount"
                                width="80"
                                align="center"
                            >
                                <template slot-scope="scope">
                                    <el-button
                                        type="text"
                                        @click="
                                            openDblTaskViewDialog(
                                                'summary',
                                                scope.row
                                            )
                                        "
                                        >{{
                                            scope.row.taskServiceCount
                                        }}</el-button
                                    >
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="操作时间"
                                prop="createTime"
                                width="100"
                                align="center"
                                sortable
                            ></el-table-column>
                            <el-table-column
                                label="操作"
                                width="100"
                                align="center"
                            >
                                <template slot-scope="scope">
                                    <el-button
                                        type="text"
                                        @click="
                                            openDblTaskViewDialog(
                                                'view',
                                                scope.row
                                            )
                                        "
                                        >查看详情</el-button
                                    >
                                    <el-dropdown
                                        v-if="isDeletableDblTask(scope.row)"
                                        size="small"
                                        trigger="click"
                                        @command="
                                            handleDblTaskCommand(
                                                arguments[0],
                                                scope.row
                                            )
                                        "
                                    >
                                        <span class="el-dropdown-link">
                                            <i
                                                class="el-icon-arrow-down el-icon--right"
                                            ></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item command="view"
                                                >查看详情</el-dropdown-item
                                            >
                                            <el-dropdown-item
                                                command="delete"
                                                divided
                                                >删除任务</el-dropdown-item
                                            >
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="el-search-pager">
                        <el-pagination
                            background
                            v-show="showDblTaskQueryPager"
                            @current-change="onDblTaskQueryCurrentPageChange"
                            :current-page.sync="dblTaskQueryForm.currentPage"
                            :page-size="dblTaskQueryForm.pageSize"
                            layout="slot, prev, pager, next, total"
                            :total="dblTaskQueryTotal"
                        >
                            <div class="el-pagination-pagesize">
                                <span class="first">每页显示</span>
                                <el-button-group>
                                    <el-button
                                        :class="{
                                            active:
                                                dblTaskQueryForm.pageSize == 10,
                                        }"
                                        @click="
                                            onDblTaskQueryPageSizeChange(10)
                                        "
                                        >10</el-button
                                    >
                                    <el-button
                                        :class="{
                                            active:
                                                dblTaskQueryForm.pageSize == 20,
                                        }"
                                        @click="
                                            onDblTaskQueryPageSizeChange(20)
                                        "
                                        >20</el-button
                                    >
                                    <el-button
                                        :class="{
                                            active:
                                                dblTaskQueryForm.pageSize == 50,
                                        }"
                                        @click="
                                            onDblTaskQueryPageSizeChange(50)
                                        "
                                        >50</el-button
                                    >
                                    <el-button
                                        :class="{
                                            active:
                                                dblTaskQueryForm.pageSize ==
                                                100,
                                        }"
                                        @click="
                                            onDblTaskQueryPageSizeChange(100)
                                        "
                                        >100</el-button
                                    >
                                </el-button-group>
                                <span class="last">条</span>
                            </div>
                        </el-pagination>
                    </div>

                    <!-- 添加/修改Dialog -->
                    <el-drawer
                        size="70%"
                        :visible.sync="dblTaskEditDialogVisible"
                        @closed="closeDblTaskEditDialog"
                    >
                        <span slot="title" class="el-drawer-title">
                            在线分派任务</span
                        >
                        <div class="el-drawer-content">
                            <el-form
                                class="el-drawer-content-body"
                                ref="dblTaskEditForm"
                                :model="dblTaskEditForm"
                                :rules="dblTaskEditRules"
                                label-width="120px"
                            >
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="任务名称"
                                            prop="taskName"
                                        >
                                            <el-col :span="12">
                                                <el-input
                                                    v-model="
                                                        dblTaskEditForm.taskName
                                                    "
                                                    :maxlength="100"
                                                ></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips">
                                                    不超过100个字符.
                                                </p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="服务类型"
                                            prop="serviceType"
                                        >
                                            <el-col :span="12">
                                                <el-select
                                                    v-model="
                                                        dblTaskEditForm.serviceType
                                                    "
                                                    clearable
                                                    class="el-full-width"
                                                >
                                                    <el-option
                                                        label="汽车服务"
                                                        :value="1"
                                                    ></el-option>
                                                    <el-option
                                                        label="市场营销"
                                                        :value="2"
                                                    ></el-option>
                                                    <el-option
                                                        label="车辆安全检测"
                                                        :value="3"
                                                    ></el-option>
                                                </el-select>
                                            </el-col>
                                            <el-col :span="12">
                                                <p
                                                    class="el-form-item-tips"
                                                ></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="团队长"
                                            prop="leaderStaffId"
                                        >
                                            <el-col :span="12">
                                                <el-select
                                                    v-model="
                                                        dblTaskEditForm.leaderStaffId
                                                    "
                                                    placeholder="请输入(支持名称或身份证模糊搜索)"
                                                    filterable
                                                    remote
                                                    :remote-method="
                                                        loadLeaderStaffs
                                                    "
                                                    :loading="
                                                        leaderStaffQueryLoading
                                                    "
                                                    @clear="
                                                        clearLeaderStaffQuerySelectOptions
                                                    "
                                                    class="el-full-width"
                                                >
                                                    <el-option
                                                        v-for="item in leaderStaffQuerySelectOptions"
                                                        :key="item.staffId"
                                                        :label="item.staffName"
                                                        :value="item.staffId"
                                                        class="leader-select-option"
                                                    >
                                                        <span
                                                            class="option-left"
                                                            >{{
                                                                item.idcard
                                                            }}</span
                                                        >
                                                        <span
                                                            class="option-right"
                                                            >{{
                                                                item.staffName
                                                            }}</span
                                                        >
                                                    </el-option>
                                                </el-select>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips">
                                                    任务分派给的团队长
                                                </p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="分派日期"
                                            prop="distributeDate"
                                        >
                                            <el-col :span="12">
                                                <el-date-picker
                                                    style="width: auto"
                                                    v-model="
                                                        dblTaskEditForm.distributeDate
                                                    "
                                                    type="date"
                                                    format="yyyy-MM-dd"
                                                    value-format="yyyy-MM-dd"
                                                >
                                                </el-date-picker>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips">
                                                    即服务日期
                                                </p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="分派金额"
                                            prop="distributeAmounts"
                                        >
                                            <el-col :span="12">
                                                <el-input
                                                    v-model="
                                                        dblTaskEditForm.distributeAmounts
                                                    "
                                                    :maxlength="10"
                                                ></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips">
                                                    分派金额最多允许2位小数
                                                </p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="分派金额区间"
                                            prop="amountRange"
                                        >
                                            <el-col :span="12">
                                                <el-input
                                                    v-model="
                                                        dblTaskEditForm.amountRange
                                                    "
                                                    :maxlength="50"
                                                ></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips">
                                                    例如：750-800
                                                </p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="税点"
                                            prop="taxThreshold"
                                        >
                                            <el-col :span="12">
                                                <el-input
                                                    v-model="
                                                        dblTaskEditForm.taxThreshold
                                                    "
                                                    :maxlength="6"
                                                ></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips">
                                                    税点最多允许2位小数
                                                </p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="含税分派金额"
                                            prop="taxedDistributeAmounts"
                                        >
                                            <el-col :span="12">
                                                <el-input
                                                    v-model="
                                                        dblTaskEditForm.taxedDistributeAmounts
                                                    "
                                                    :maxlength="10"
                                                    readonly
                                                ></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips">
                                                    含税分派金额 = 分派金额 *
                                                    ((100 + 税点) / 100)
                                                </p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="任务发布方"
                                            prop="taskProduceOrgId"
                                        >
                                            <el-col :span="12">
                                                <el-select
                                                    v-model="
                                                        dblTaskEditForm.taskProduceOrgId
                                                    "
                                                    clearable
                                                    filterable
                                                    :filter-method="
                                                        filterAllOrgs
                                                    "
                                                    @visible-change="
                                                        resetOrgSelectFilterQuery
                                                    "
                                                    class="el-full-width"
                                                >
                                                    <el-option
                                                        v-for="item in dblTaskQueryOrgSelectOptions"
                                                        :key="item.orgId"
                                                        :label="item.orgName"
                                                        :value="item.orgId"
                                                        class="org-select-option"
                                                    >
                                                        <span
                                                            class="option-left"
                                                            >{{
                                                                item.orgCode
                                                            }}</span
                                                        >
                                                        <span
                                                            class="option-right"
                                                            >{{
                                                                item.orgName
                                                            }}</span
                                                        >
                                                    </el-option>
                                                </el-select>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips">
                                                    来款公司
                                                </p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                    <el-col
                                        :span="12"
                                        v-if="showDblTaskConsumeOrgSelect"
                                    >
                                        <el-form-item
                                            label="任务接受方"
                                            prop="taskConsumeOrgId"
                                            :rules="[
                                                {
                                                    required: true,
                                                    message:
                                                        '请选择任务接受方!',
                                                },
                                            ]"
                                        >
                                            <el-col :span="12">
                                                <el-select
                                                    v-model="
                                                        dblTaskEditForm.taskConsumeOrgId
                                                    "
                                                    clearable
                                                    filterable
                                                    :filter-method="
                                                        filterAllOrgs
                                                    "
                                                    @visible-change="
                                                        resetOrgSelectFilterQuery
                                                    "
                                                    class="el-full-width"
                                                >
                                                    <el-option
                                                        v-for="item in dblTaskQueryOrgSelectOptions"
                                                        :key="item.orgId"
                                                        :label="item.orgName"
                                                        :value="item.orgId"
                                                        class="org-select-option"
                                                    >
                                                        <span
                                                            class="option-left"
                                                            >{{
                                                                item.orgCode
                                                            }}</span
                                                        >
                                                        <span
                                                            class="option-right"
                                                            >{{
                                                                item.orgName
                                                            }}</span
                                                        >
                                                    </el-option>
                                                </el-select>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips">
                                                    服务公司
                                                </p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                            <div class="el-drawer-content-footer">
                                <el-button
                                    icon="fas fa-ban"
                                    @click="closeDblTaskEditDialog"
                                    >取 消</el-button
                                >
                                <el-button
                                    type="primary"
                                    icon="far fa-save"
                                    @click="saveDblTask"
                                    :loading="submiting"
                                    >确 定</el-button
                                >
                            </div>
                        </div>
                    </el-drawer>

                    <!-- 导入Dialog -->
                    <el-drawer
                        size="70%"
                        :visible.sync="dblTaskImportDialogVisible"
                        @closed="closeDblTaskImportDialog"
                    >
                        <span slot="title" class="el-drawer-title"
                            >批量分派任务</span
                        >
                        <div class="el-drawer-content">
                            <el-form
                                class="el-drawer-content-body"
                                v-custom-validator-apply="dblTaskImportRules"
                                ref="dblTaskImportForm"
                                :model="dblTaskImportForm"
                                :rules="dblTaskImportRules"
                                label-width="300px"
                            >
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="上传EXCEL文件"
                                            prop="uploadExcelFilePath"
                                        >
                                            <el-col :span="12">
                                                <el-upload
                                                    class="upload-excel"
                                                    ref="dblTaskImportUploader"
                                                    name="uploadFile"
                                                    :multiple="false"
                                                    :limit="1"
                                                    :on-exceed="
                                                        handleImportExcelExceed
                                                    "
                                                    :headers="uploadHeaders"
                                                    :action="
                                                        importExcelUploadUrl
                                                    "
                                                    :data="
                                                        importExcelUploadParam
                                                    "
                                                    :before-upload="
                                                        beforeImportExcelUpload
                                                    "
                                                    :on-remove="
                                                        handleImportExcelRemove
                                                    "
                                                    :on-success="
                                                        handleImportExcelUploadSuccess
                                                    "
                                                    :on-error="
                                                        handleUploadError
                                                    "
                                                >
                                                    <el-button
                                                        slot="trigger"
                                                        size="small"
                                                        type="primary"
                                                        icon="fas fa-plus-circle"
                                                        >选择文件</el-button
                                                    >
                                                    <a
                                                        class="excel-template"
                                                        href="javascript:;"
                                                        @click="
                                                            downloadTemplateExcel
                                                        "
                                                        >下载模板</a
                                                    >
                                                    <div
                                                        class="el-upload__tip"
                                                        slot="tip"
                                                    >
                                                        只能上传xls|xlsx格式的EXCEL文件，大小不超过1MB!
                                                    </div>
                                                </el-upload>
                                                <div
                                                    v-if="
                                                        showDblTaskImportFeedback
                                                    "
                                                >
                                                    <p class="import-feedback">
                                                        上传EXCEL中部分数据校验不通过，请点此<a
                                                            href="javascript:;"
                                                            @click="
                                                                downloadFeedbackExcel
                                                            "
                                                            >链接下载</a
                                                        >反馈信息予以更正并重新上传导入.
                                                    </p>
                                                </div>
                                            </el-col>
                                            <el-col :span="12">
                                                <p
                                                    class="el-form-item-tips"
                                                ></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                            <div class="el-drawer-content-footer">
                                <el-button
                                    icon="fas fa-ban"
                                    @click="closeDblTaskImportDialog"
                                    >取 消</el-button
                                >
                                <el-button
                                    type="primary"
                                    icon="far fa-save"
                                    @click="importDblTask"
                                    :loading="submiting"
                                    >确 定</el-button
                                >
                            </div>
                        </div>
                    </el-drawer>

                    <!-- 查看Dialog -->
                    <el-drawer
                        :with-header="false"
                        size="80%"
                        :visible.sync="dblTaskViewDialogVisible"
                        @closed="closeDblTaskViewDialog"
                    >
                        <div class="el-drawer-content">
                            <el-tabs
                                class="el-drawer-content-body"
                                v-model="dblTaskViewActiveTabName"
                            >
                                <el-tab-pane
                                    label="任务详情信息"
                                    name="dblTaskViewBasicInfo"
                                >
                                    <el-form
                                        class="el-form-detail"
                                        inline
                                        label-position="right"
                                        label-width="120px"
                                        label-suffix="："
                                    >
                                        <el-form-item label="任务ID">{{
                                            dblTaskViewForm.taskId
                                        }}</el-form-item>
                                        <el-form-item label="任务名称">{{
                                            dblTaskViewForm.taskName
                                        }}</el-form-item>

                                        <el-form-item
                                            label="服务类型"
                                            style="width: 100%"
                                            >{{
                                                dblTaskViewForm.serviceTypeName
                                            }}</el-form-item
                                        >

                                        <el-form-item label="任务发布方">{{
                                            dblTaskViewForm.taskProduceOrgName
                                        }}</el-form-item>
                                        <el-form-item label="任务接受方">{{
                                            dblTaskViewForm.taskConsumeOrgName
                                        }}</el-form-item>

                                        <el-form-item label="团队长">{{
                                            dblTaskViewForm.leaderStaffName
                                        }}</el-form-item>
                                        <el-form-item label="分派日期">{{
                                            dblTaskViewForm.distributeDate
                                        }}</el-form-item>

                                        <el-form-item label="分派金额">{{
                                            dblTaskViewForm.distributeAmounts
                                        }}</el-form-item>
                                        <el-form-item label="分派金额区间">{{
                                            dblTaskViewForm.amountRange
                                        }}</el-form-item>

                                        <el-form-item label="含税分派金额">{{
                                            dblTaskViewForm.taxedDistributeAmounts
                                        }}</el-form-item>
                                        <el-form-item label="税点">{{
                                            dblTaskViewForm.taxThreshold
                                        }}</el-form-item>

                                        <el-form-item
                                            label="服务数"
                                            style="width: 100%"
                                            >{{
                                                dblTaskViewForm.taskServiceCount
                                            }}</el-form-item
                                        >

                                        <el-form-item label="操作时间">{{
                                            dblTaskViewForm.createTime
                                        }}</el-form-item>
                                        <el-form-item label="操作人">{{
                                            dblTaskViewForm.createByName
                                        }}</el-form-item>
                                    </el-form>
                                </el-tab-pane>
                                <el-tab-pane
                                    label="任务分派清单"
                                    name="dblTaskViewSummary"
                                >
                                    <visp-task-service
                                        :task-id="dblTaskViewForm.taskId"
                                        :service-type="
                                            dblTaskViewForm.serviceType
                                        "
                                        :is-producer="isProducer"
                                    ></visp-task-service>
                                </el-tab-pane>
                            </el-tabs>
                            <div
                                class="el-drawer-content-footer"
                                style="padding: 15px 0"
                            >
                                <el-button
                                    icon="fas fa-ban"
                                    @click="closeDblTaskViewDialog"
                                    >关 闭</el-button
                                >
                            </div>
                        </div>
                    </el-drawer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { defaultApiErrorHandler, PLATFORM_API } from '@/api.js';
import { mapSort, parseFilename } from '@/utils.js';
import FileSaver from 'file-saver';
import { ALL_ORG_ID } from '@/visp.js';

const EXCEL_TYPES = ['xls', 'xlsx'];
const AMOUNT_RANGE_PATTERN = /^\d+-\d+$/;
const AMOUNT_PATTERN = /^([0-9])+(\.[0-9]{1,2})?$/;

const checkDistributeAmount = (rules, value, callback) => {
    let number = parseFloat(value);
    if (!isNaN(number)) {
        if (number > 0) {
            callback();
        } else {
            callback(new Error('分派金额必须大于0!'));
        }
    }
    callback();
};

const checkAmountRange = (rules, value, callback) => {
    if (value) {
        if (AMOUNT_RANGE_PATTERN.test(value)) {
            let [amount1, amount2] = value.split('-');
            if (amount1 == amount2) {
                callback(new Error('分派金额区间不合法!'));
            } else {
                callback();
            }
        } else {
            callback(new Error('分派金额区间不合法!'));
        }
    }
    callback();
};

export default {
    name: 'DblDistribTask',
    data() {
        return {
            submiting: false,
            allOrgList: [],
            orgSelectFilterQuery: '',
            dblTaskList: [],
            dblTaskQueryLoading: false,
            dblTaskQuering: false,
            dblTaskQueryForm: {
                taskProduceOrgId: '',
                taskConsumeOrgId: '',
                startDistributeDate: '',
                endDistributeDate: '',
                distributeDateRange: [],
                pageSize: 10,
                currentPage: 1,
            },
            dblTaskQueryTotal: 0,
            dblTaskQuerySort: {
                prop: 'createTime',
                order: 'descending',
            },
            currentActionType: 'import',
            dblTaskEditDialogVisible: false,
            dblTaskEditForm: {
                taskId: '',
                taskName: '',
                leaderStaffId: '',
                serviceType: '',
                distributeDate: '',
                distributeAmounts: '0',
                taxedDistributeAmounts: '0',
                amountRange: '750-800',
                taxThreshold: '0',
                taskProduceOrgId: '',
                taskConsumeOrgId: '',
            },
            dblTaskEditRules: {
                serviceType: [
                    {
                        required: true,
                        message: '请选择服务类型!',
                    },
                ],
                leaderStaffId: [
                    {
                        required: true,
                        message: '请选择团队长!',
                    },
                ],
                distributeDate: [
                    {
                        required: true,
                        message: '请选择分派日期!',
                    },
                ],
                distributeAmounts: [
                    {
                        required: true,
                        message: '分派金额不能为空!',
                    },
                    {
                        pattern: AMOUNT_PATTERN,
                        message: '分派金额必须是正数且小数部分至多2位!',
                    },
                    {
                        validator: checkDistributeAmount,
                    },
                ],
                taxedDistributeAmounts: [
                    {
                        required: true,
                        message: '含税分派金额不能为空!',
                    },
                ],
                amountRange: [
                    {
                        validator: checkAmountRange,
                    },
                ],
                taxThreshold: [
                    {
                        required: true,
                        message: '税点不能为空!',
                    },
                    {
                        pattern: AMOUNT_PATTERN,
                        message: '税点必须是非负数且小数部分至多2位!',
                    },
                ],
                taskProduceOrgId: [
                    {
                        required: true,
                        message: '请选择任务发布方!',
                    },
                ],
            },
            leaderStaffQueryLoading: false,
            leaderStaffQuerySelectOptions: [],
            dblTaskViewDialogVisible: false,
            dblTaskImportDialogVisible: false,
            dblTaskViewActiveTabName: 'dblTaskViewBasicInfo',
            importExcelUploadUrl: PLATFORM_API.of(
                '/api/xupload/protected/file'
            ),
            importExcelUploadParam: {
                renameStrategy: 'ORIGINAL_FILENAME_AND_UUID',
                formatLimit: EXCEL_TYPES.join(','),
            },
            dblTaskImportForm: {
                uploadExcelFileName: '',
                uploadExcelFilePath: '',
            },
            dblTaskImportRules: {
                uploadExcelFilePath: [
                    {
                        required: true,
                        message: '请选择导入Excel文件!',
                    },
                ],
            },
            showDblTaskImportFeedback: false,
            dblTaskViewForm: {
                taskId: '',
                taskName: '',
                serviceType: '',
                serviceTypeName: '',
                leaderStaffId: '',
                leaderStaffName: '',
                distributeDate: '',
                distributeAmounts: '',
                taxedDistributeAmounts: '',
                amountRange: '',
                taxThreshold: '',
                taskProduceOrgId: '',
                taskProduceOrgName: '',
                taskConsumeOrgId: '',
                taskConsumeOrgName: '',
                createTime: '',
                createBy: '',
                createByName: '',
                taskServiceCount: 0,
            },
        };
    },
    computed: {
        loginUser() {
            return this.$store.state.loginUserAllData.loginUser;
        },
        showDblTaskQueryPager() {
            if (this.dblTaskQuering || this.dblTaskQueryTotal == 0) {
                return false;
            } else {
                return true;
            }
        },
        dblTaskQueryOrgSelectOptions() {
            if (this.orgSelectFilterQuery) {
                return this.allOrgList.filter((org) => {
                    if (org.orgCode.indexOf(this.orgSelectFilterQuery) > -1) {
                        return true;
                    }
                    if (org.orgName.indexOf(this.orgSelectFilterQuery) > -1) {
                        return true;
                    }
                    return false;
                });
            } else {
                return this.allOrgList.filter((org) => true);
            }
        },
        showDblTaskConsumeOrgSelect() {
            //如果当前用户是拥有全部组织的人?那么需要展示选择任务接受方的，否则默认使用当前操作人的所属组织作为任务接受方
            return this.loginUser.orgId == ALL_ORG_ID;
        },
        uploadHeaders() {
            let headers = {
                Accept: 'application/json',
            };
            let accessToken = this.$store.getters.getAccessToken();
            if (accessToken && accessToken.access_token) {
                headers['Authorization'] = 'bearer ' + accessToken.access_token;
            }
            return headers;
        },
        isProducer() {
            return (
                this.dblTaskViewForm.taskProduceOrgId == this.loginUser.orgId
            );
        },
    },
    created() {},
    mounted() {
        this.loadAllOrgList();
        this.queryDblTaskList(1000);
    },
    methods: {
        isDeletableDblTask(row) {
            //当前登录者创建的任务
            return (
                ALL_ORG_ID == this.loginUser.orgId ||
                row.taskConsumeOrgId == this.loginUser.orgId
            );
        },
        filterAllOrgs(value) {
            this.orgSelectFilterQuery = value;
        },
        loadAllOrgList() {
            let url = PLATFORM_API.of('/api/platform/upms/org/all');
            this.$http
                .get(url)
                .then((response) => {
                    let result = response.data;
                    if (result.success) {
                        this.allOrgList = result.data;
                    }
                })
                .catch(defaultApiErrorHandler);
        },
        resetOrgSelectFilterQuery() {
            this.orgSelectFilterQuery = '';
        },
        loadLeaderStaffs(query) {
            if (query) {
                this.leaderStaffQueryLoading = true;
                let url = PLATFORM_API.of('/api/platform/visp/staff/leaders');
                this.$http
                    .get(url, {
                        params: { staffName: query, idcard: query },
                    })
                    .then((response) => {
                        let result = response.data;
                        if (result.success) {
                            this.leaderStaffQuerySelectOptions = result.data;
                        } else {
                            this.leaderStaffQuerySelectOptions = [];
                        }
                    })
                    .catch((error) => {
                        this.leaderStaffQuerySelectOptions = [];
                        defaultApiErrorHandler.call(this, error);
                    })
                    .then(() => {
                        this.leaderStaffQueryLoading = false;
                    });
            }
        },
        clearLeaderStaffQuerySelectOptions() {
            this.leaderStaffQuerySelectOptions = [];
        },
        queryDblTaskList(loading) {
            this.dblTaskQueryForm.currentPage = 1;
            this.doQueryDblTaskList(loading);
        },
        doQueryDblTaskList(loading) {
            this.dblTaskQuering = true;
            if (loading) {
                this.dblTaskQueryLoading = true;
            }
            setTimeout(() => {
                this.dblTaskQueryForm.startDistributeDate =
                    this.dblTaskQueryForm.distributeDateRange[0];
                this.dblTaskQueryForm.endDistributeDate =
                    this.dblTaskQueryForm.distributeDateRange[1];
                let params = Object.assign(
                    {},
                    this.dblTaskQueryForm,
                    mapSort(this.dblTaskQuerySort)
                );
                delete params.distributeDateRange;
                this.$http
                    .get(PLATFORM_API.of('/api/platform/visp/dbltask/list'), {
                        params: params,
                    })
                    .then((response) => {
                        let result = response.data;
                        if (result.success) {
                            this.dblTaskList = result.data;
                            this.dblTaskQueryTotal = result.totalRowCount;
                        } else {
                            this.dblTaskList = [];
                            this.dblTaskQueryTotal = 0;
                            this.$message.error(result.message);
                        }
                    })
                    .catch((error) => {
                        this.dblTaskList = [];
                        this.dblTaskQueryTotal = 0;
                        defaultApiErrorHandler.call(this, error);
                    })
                    .then(() => {
                        if (loading) {
                            this.dblTaskQueryLoading = false;
                        }
                        this.dblTaskQuering = false;
                    });
            }, loading);
        },
        resetDblTaskQueryForm() {
            this.$refs.dblTaskQueryForm.resetFields();
        },
        onDblTaskQuerySortChange(parameter) {
            if (
                this.dblTaskQuerySort.prop != parameter.prop ||
                this.dblTaskQuerySort.order != parameter.order
            ) {
                this.dblTaskQuerySort.prop = parameter.prop;
                this.dblTaskQuerySort.order = parameter.order;
                this.queryDblTaskList(1000);
            }
        },
        onDblTaskQueryPageSizeChange(pageSize) {
            this.dblTaskQueryForm.pageSize = pageSize;
            this.queryDblTaskList(1000);
        },
        onDblTaskQueryCurrentPageChange(currentPage) {
            this.dblTaskQueryForm.currentPage = currentPage;
            this.doQueryDblTaskList(1000);
        },
        openDblTaskEditDialog(cmd, row) {
            this.currentActionType = cmd;
            this.dblTaskEditDialogVisible = true;
        },
        closeDblTaskEditDialog() {
            this.dblTaskEditDialogVisible = false;
            this.$refs.dblTaskEditForm.resetFields();
            this.clearLeaderStaffQuerySelectOptions();
            //手动reset
            this.dblTaskEditForm.taskId = '';
        },
        updateDistributeAmounts() {
            let taxThreshold = this.dblTaskEditForm.taxThreshold;
            if (AMOUNT_PATTERN.test(taxThreshold)) {
                taxThreshold = parseFloat(taxThreshold);
            } else {
                taxThreshold = 0;
            }
            let distributeAmounts = this.dblTaskEditForm.distributeAmounts;
            if (AMOUNT_PATTERN.test(distributeAmounts)) {
                distributeAmounts = parseFloat(distributeAmounts);
            } else {
                distributeAmounts = 0;
            }
            //结果四舍五入保留2位小数
            this.dblTaskEditForm.taxedDistributeAmounts = (
                distributeAmounts *
                ((taxThreshold + 100) / 100.0)
            ).toFixed(2);
        },
        handleDblTaskCommand(cmd, row) {
            if (cmd == 'view') {
                this.openDblTaskViewDialog(cmd, row);
            } else if (cmd == 'delete') {
                this.deleteDblTask(row);
            }
        },
        openDblTaskViewDialog(cmd, row) {
            this.currentActionType = cmd;
            if (cmd == 'summary') {
                this.dblTaskViewActiveTabName = 'dblTaskViewSummary';
            } else {
                this.dblTaskViewActiveTabName = 'dblTaskViewBasicInfo';
            }
            this.dblTaskViewDialogVisible = true;
            Vue.nextTick(() => {
                Object.keys(this.dblTaskViewForm).forEach((name) => {
                    let value = row[name];
                    this.dblTaskViewForm[name] = value;
                });
            });
        },
        closeDblTaskViewDialog() {
            this.dblTaskViewDialogVisible = false;
            Object.keys(this.dblTaskViewForm).forEach((name) => {
                this.dblTaskViewForm[name] = '';
            });
        },
        openDblTaskImportDialog() {
            this.dblTaskImportDialogVisible = true;
        },
        closeDblTaskImportDialog() {
            this.dblTaskImportDialogVisible = false;
            this.showDblTaskImportFeedback = false;
            this.$refs.dblTaskImportForm.resetFields();
            this.$refs.dblTaskImportUploader.clearFiles();
        },
        saveDblTask() {
            let url = PLATFORM_API.of('/api/platform/visp/dbltask/create');
            this.$refs.dblTaskEditForm.validate((valid) => {
                if (valid && !this.submiting) {
                    this.$confirm('您确定要分派该任务?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                    }).then(() => {
                        this.submiting = true;
                        setTimeout(() => {
                            this.$http
                                .post(url, this.dblTaskEditForm)
                                .then((response) => {
                                    let result = response.data;
                                    if (result.success) {
                                        this.closeDblTaskEditDialog();
                                        this.$message.success(result.message);
                                        this.queryDblTaskList(1000);
                                    } else {
                                        this.$message.error(result.message);
                                    }
                                })
                                .catch(defaultApiErrorHandler)
                                .then(() => {
                                    this.submiting = false;
                                });
                        }, 1500);
                    });
                } else {
                    return false;
                }
            });
        },
        importDblTask() {
            let url = PLATFORM_API.of('/api/platform/visp/dbltask/import');
            this.$refs.dblTaskImportForm.validate((valid) => {
                if (valid && !this.submiting) {
                    this.submiting = true;
                    this.$http
                        .post(url, this.dblTaskImportForm)
                        .then((response) => {
                            let result = response.data;
                            if (result.success) {
                                this.closeDblTaskImportDialog();
                                this.$message.success(result.message);
                                this.queryDblTaskList(1000);
                            } else {
                                this.$message.error(result.message);
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                            defaultApiErrorHandler.call(
                                this,
                                error,
                                (result) => {
                                    if (result.code == 400) {
                                        this.showDblTaskImportFeedback = true;
                                    }
                                }
                            );
                        })
                        .then(() => {
                            this.submiting = false;
                        });
                } else {
                    return false;
                }
            });
        },
        deleteDblTask(row) {
            let url = PLATFORM_API.of(
                '/api/platform/visp/dbltask/delete/' + row.taskId
            );
            this.$confirm('您确定要删除该任务?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                this.$http
                    .delete(url)
                    .then((response) => {
                        let result = response.data;
                        if (result.success) {
                            this.$message.success(result.message);
                            this.queryDblTaskList(1000);
                        } else {
                            this.$message.error(result.message);
                        }
                    })
                    .catch(defaultApiErrorHandler);
            });
        },
        downloadTemplateExcel() {
            let url = PLATFORM_API.of('/api/xdownload/store/file');
            this.$http
                .post(
                    url,
                    {
                        targetFileName: '任务批量导入模板.xlsx',
                        targetFilePath:
                            '/excel/templates/任务批量导入模板.xlsx',
                    },
                    {
                        responseType: 'blob', // 设置响应数据类型
                    }
                )
                .then((response) => {
                    let fileblob = new Blob([response.data]);
                    let filename = decodeURI(
                        parseFilename(response.headers['content-disposition'])
                    );
                    FileSaver.saveAs(fileblob, filename);
                })
                .catch(defaultApiErrorHandler);
        },
        downloadFeedbackExcel() {
            let url = PLATFORM_API.of('/api/xdownload/temp/file');
            this.$http
                .post(
                    url,
                    {
                        targetFileName:
                            this.dblTaskImportForm.uploadExcelFileName,
                        targetFilePath:
                            this.dblTaskImportForm.uploadExcelFilePath,
                    },
                    {
                        responseType: 'blob', // 设置响应数据类型
                    }
                )
                .then((response) => {
                    let fileblob = new Blob([response.data]);
                    let filename = decodeURI(
                        parseFilename(response.headers['content-disposition'])
                    );
                    FileSaver.saveAs(fileblob, filename);
                })
                .catch(defaultApiErrorHandler);
        },
        beforeImportExcelUpload(file) {
            let fileName = file.name;
            if (fileName.replace(/\s+/g, '') != fileName) {
                this.$message.error('上传文件名不能包含空格!');
                return false;
            }
            let fileType = fileName
                .substring(fileName.lastIndexOf('.') + 1)
                .toLowerCase();
            if (EXCEL_TYPES.indexOf(fileType) == -1) {
                this.$message.error(
                    '上传文件只能是EXCEL(xls、xlsx)格式的文件!'
                );
                return false;
            }
            if (file.size > 0 && file.size / 1024 / 1024 > 1) {
                this.$message.error('上传EXCEL文件大小不能超过1MB!');
                return false;
            }
            return true;
        },
        handleImportExcelExceed(file, fileList) {
            this.$message.error('最多只能上传一个文件!若要重新上传请先删除.');
            return false;
        },
        handleImportExcelUploadSuccess(response, file, fileList) {
            file.path = response.data.path;
            this.dblTaskImportForm.uploadExcelFileName = response.data.name;
            this.dblTaskImportForm.uploadExcelFilePath = response.data.path;
            this.showDblTaskImportFeedback = false;
            this.$refs.dblTaskImportForm.validateField('uploadExcelFilePath');
        },
        handleImportExcelRemove(file, fileList) {
            this.showDblTaskImportFeedback = false;
            this.dblTaskImportForm.uploadExcelFileName = '';
            this.dblTaskImportForm.uploadExcelFilePath = '';
            if (file && file.path) {
                this.$http.get(
                    PLATFORM_API.of(
                        '/api/xupload/protected/remove?path=' + file.path
                    )
                );
            }
        },
        handleUploadError(error, file, fileList) {
            try {
                let result = JSON.parse(error.message);
                this.$message.error(result.message);
            } catch (e) {
                console.error(e);
            }
        },
    },
    watch: {
        'dblTaskEditForm.distributeAmounts': function (newVal, oldVal) {
            this.updateDistributeAmounts(); //更新总金额
        },
        'dblTaskEditForm.taxThreshold': function (newVal, oldVal) {
            this.updateDistributeAmounts(); //更新总金额
        },
    },
};
</script>
<style lang="scss">
.x-task-remark {
    line-height: 60px !important;
    font-size: 14px;
    color: #729e08;
    float: right;
}
.upload-excel {
    display: block;
    position: relative;

    .excel-template {
        display: inline-block;
        position: absolute;
        right: 0;
        top: 0;
        font-size: 13px;
    }
}
.org-select-option,
.leader-select-option {
    .option-left {
        float: left;
        color: $--color-primary;
        font-size: 13px;
        padding-right: 50px;
    }
    .option-right {
        float: right;
    }
}
.import-feedback {
    margin-top: 10px;
    padding: 10px;
    line-height: 1.5;
    background-color: mix($--color-white, $--color-danger, 90%);
    border-radius: 4px;
    font-size: 13px;
    color: $--color-danger;
    a {
        color: $--color-blue;
    }
}
</style>